import {
  HttpClient,
  HttpParams,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  CreateFeedbackRequest,
  FeedbackDto,
  UserFeedbackListItem,
  UserFeedbackListRequest,
} from '../models/feedback.models';
import { PagedResult } from './log.service';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  private http = inject(HttpClient);

  private readonly apiUrl = `${environment.apiUrl}/api/userfeedback`;

  /**
   * Submit a piece of user feedback.
   */
  submitFeedback(request: CreateFeedbackRequest): Observable<FeedbackDto> {
    return this.http.post<FeedbackDto>(this.apiUrl, request);
  }

  /**
   * Get filtered and paginated user feedback for the admin User Feedback page.
   */
  getUserFeedback(
    request: UserFeedbackListRequest = {},
  ): Observable<PagedResult<UserFeedbackListItem>> {
    let params = new HttpParams();

    if (request.page) params = params.set('page', request.page.toString());
    if (request.pageSize)
      params = params.set('pageSize', request.pageSize.toString());
    if (request.search) params = params.set('search', request.search);
    if (request.categories && request.categories.length > 0) {
      params = params.set('categories', request.categories.join(','));
    }
    if (request.startDate) params = params.set('startDate', request.startDate);
    if (request.endDate) params = params.set('endDate', request.endDate);
    if (request.sortBy) params = params.set('sortBy', request.sortBy);
    if (request.sortDirection)
      params = params.set('sortDirection', request.sortDirection);

    return this.http
      .get<PagedResult<UserFeedbackListItem>>(this.apiUrl, { params });
  }
}
